module.exports = __webpack_public_path__ + "img/time-clock-circle-alternate.6a0e299f.svg";